export const emptyRequestTypes = {
  per_page: 20,
  request_types: [],
  request_types_count: 0,
};